import { useEffect, useState } from 'react';
import { Toast } from './ui/Toast';

export function ChronosToast() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.get('chronos') === 'linked') {
      setOpen(true);
      url.searchParams.delete('chronos');
      window.history.replaceState({}, '', url.pathname + (url.search || ''));
    }
  }, []);

  return <Toast open={open} onOpenChange={setOpen} message="Chronos linked ✓" />;
}
